import isNil from "~/kernel/validation/isNil";
import VerificationStatus from "../../models/companyVerification/VerificationStatus";
import guaranteedVerificationStatus from "./guaranteedVerificationStatus";

export default function isCompanyVerified(company: {
  verificationStatus: string | null;
}) {
  if (isNil(company.verificationStatus)) {
    return false;
  }
  const status = guaranteedVerificationStatus(company.verificationStatus);

  return status === VerificationStatus.Accepted;
}
